import axios from "axios";
import { apiCore } from '../constants'
import { disconnectSocket } from '../state/socket'
import axiosRetry from 'axios-retry';


export const axiosService = () => {

    axiosRetry(axios, {
        retries: 3,
        async retryCondition(error) {
            if (error.response?.status === 403) {
                handleExpiredRefresh()
                return false;
            }

            if (error.response?.status === 401 && !error.config.url.endsWith("login")) {
                if (error.config.url.endsWith("refresh") || error.config.url.endsWith("actives")) {
                    handleExpiredRefresh();
                    return false;
                }
                await handleExpiredAccess();
                return true;
            }

            return false;
        },
    });

    axios.interceptors.request.use(
        async (config) => {
            if (!config.url.endsWith("refresh")) {
                if (config.headers.Authorization) {
                    try {
                        const newToken = await JSON.parse(localStorage.getItem('authToken'));
                        config.headers.Authorization = `Bearer ${newToken}`;
                    } catch (error) {
                        console.error('Error refreshing token:', error);
                    }
                }
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const apiRequest = async ({ url, method, data = {}, responseType, otherToken }) => {
        const baseURL = apiCore
        const token = otherToken ? otherToken : await JSON.parse(localStorage.getItem('authToken'));

        const configAxios = {
            method,
            url: `${baseURL}${url}`,
            data,
            responseType: responseType || 'json',
            timeout: 300000,
            headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
            },
        };

        try {
            const response = await axios(configAxios);
            return responseType === 'blob' ? response : response.data;
        } catch (error) {
            console.error("API Request Error:", error);
            throw error;
        }
    };

    const handleExpiredAccess = async () => {
        const refreshToken = await JSON.parse(localStorage.getItem('refreshToken'));
        const url = `/auth/refresh`;

        try {
            const response = await apiRequest({
                url: url,
                method: "POST",
                otherToken: refreshToken
            });

            const newToken = response.data.tokens.accessToken;
            await localStorage.setItem('authToken', JSON.stringify(newToken));
            await localStorage.setItem('refreshToken', JSON.stringify(response.data.tokens.refreshToken));

        } catch (refreshError) {
            console.error(refreshError)
        }
    }

    const handleExpiredRefresh = () => {
        localStorage.clear()
        disconnectSocket()
        window.location.href = '/login';
    }

    return { apiRequest };
};
